export default __webpack_public_path__ + "static/media/twitter-logo.28db309d.svg";